import { gql } from '@apollo/client';
import TENANT_ORDER_OPERATOR from 'api/fragments/TENANT_ORDER_OPERATOR';
const ADD_TENANT_ORDER_OPERATOR = gql `
  ${TENANT_ORDER_OPERATOR}
  mutation AddOrderOperator(
    $tenantId: ID!
    $name: String
    $vatNumber: String
    $countryOfOrigin: String
    $addressPostalCode: String
    $addressCity: String
    $addressStreet: String
    $addressNumber: String
    $emailAddress: String
    $contactPhone: String
  ) {
    addOrderOperator(
      tenantId: $tenantId
      name: $name
      vatNumber: $vatNumber
      countryOfOrigin: $countryOfOrigin
      addressPostalCode: $addressPostalCode
      addressCity: $addressCity
      addressStreet: $addressStreet
      addressNumber: $addressNumber
      emailAddress: $emailAddress
      contactPhone: $contactPhone
    ) {
      orderOperator {
        ...TenantOrderOperatorFragment
      }
    }
  }
`;
export default ADD_TENANT_ORDER_OPERATOR;
